"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @param {Recover} recover A reference to the Recover class
 * @class Actions
 * @classdesc Actions Class for Indexing and Getting Actions.
 */
var Actions = /** @class */ (function () {
    // /**
    //  *Creates an instance of Actions.
    //  * @property {Recover} recover A reference to the Recover class
    //  * @memberof Actions
    //  * @constructor
    //  */
    function Actions(recover) {
        var _this = this;
        this.recover = recover;
        /**
         *
         *
         * @memberof Actions
         * @returns {SuccessfulIndexActions} Returns a message and an array of all actions
         * @description Returns an index of all Actions
         */
        this.index = function () {
            return _this.recover.request("/actions", "GET", null, null);
        };
        /**
         *
         *
         * @memberof Actions
         * @returns {SuccessfulGetAction} Returns a message and a single Action
         * @property {number} id - A reference to a single Action
         * @description Get a single action
         */
        this.get = function (id) {
            return _this.recover.request("/actions/" + id, "GET", null, null);
        };
    }
    return Actions;
}());
exports.default = Actions;
